import {DialogConsumerContentDefaultBox} from './dialog-consumer-content.default.box';
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {DialogConsumerContentCasino777Box} from "./dialog-consumer-content.casino777.box";
import {DialogConsumerContentMrGreenCisBox} from './dialog-consumer-content.mrgreenCis.box';

export const DialogConsumerContentBox = styledByTheme(DialogConsumerContentDefaultBox)
    .forCasino777(DialogConsumerContentCasino777Box)
    .forMrGreenCis(DialogConsumerContentMrGreenCisBox)
    .apply();